import { mapState, mapMutations, mapGetters } from "vuex";
import config from "../../config/index";

const minin = {
  data() {
    return {
      tabIdx: 0,
      tabData: [],
      formInline: {},
      formCtrl: [],
      page: 1,
      limit: config.PAGE_SIZES[0] || 10,
      total: 0,
      tableData: [],
      getTotalProperty: [],
      viewMode: false,
      loading: false,
      listLoading: false,
      getListUrl: 'rec',
      baseParams: [],
      delUrl: 'delre',
      getOptionUrl: 'index',
      btns: [],
      selection: [],
      mform: {},
      mformCtrl: [],
      modalSubmitUrl: 'addedu',
      searchKeyOptions: [],
      allBtnWidth: '100px',
      tempCols: [],
      rform: {},
      formCtrlRight: {
        label: "选择字段",
        keyName: "keys",
        type: "select",
        multiple: true,
        collapseTags: true,
        options: [],
      },
      defaultTh: [],
      userviewhistory: {},
      // 储存初始值，用于重置
      MONTH: null,
    };
  },
  computed: {
    ...mapState([
      'user',
      'store',
    ]),
    ...mapGetters([
      'tabIdxMemo',
    ]),
    DATE_OBJ() {
      const date = new Date()
      const y = date.getFullYear() + ''
      let m = date.getMonth() + 1
      let d = date.getDate()
      let s = date.getTime()
      m > 9 ? null : m = '0' + m
      d > 9 ? null : d = '0' + d
      return {
        y, m, d, s
      }
    },
    DATE() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      m > 9 ? null : m = '0' + m
      d > 9 ? null : d = '0' + d
      return `${y}-${m}-${d}`
    },
    CURR_MONTH() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      m > 9 ? null : m = '0' + m
      // console.log(y, m)
      return `${y}-${m}`
    },
    LAST_MONTH() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth()
      m > 9 ? null : m = '0' + m
      // console.log(y, m)
      return `${y}-${m}`
    },
  },
  methods: {
    ...mapMutations(['setTabIdx', 'setStore']),
    onSortChange({ prop, order }) {
      // console.log({ ...column })
      // console.log(prop)
      // console.log(order)
      if (prop) this.formInline['authname'] = prop
      if (order) this.formInline['type'] = (order.replace('ending', ''))
      // console.log({ ...this.formInline })
      this.getList()
    },
    setListHistory() {
      const arr = this.userviewhistory[location.href] || []
      this.tableData.map(v => {
        if (arr.includes(v.id)) {
          v.viewed = true
        }
      })
    },
    getUserViewHistory() {
      const str = localStorage.getItem('userviewhistory')
      // console.log(str)
      this.userviewhistory = JSON.parse(str) || {}
    },
    setUserViewHistory(id) {
      const arr = this.userviewhistory[location.href] || []
      if (!arr.includes(id)) {
        arr.push(id)
      }
      this.userviewhistory[location.href] = arr
      console.log(this.userviewhistory[location.href])
      localStorage.setItem('userviewhistory', JSON.stringify(this.userviewhistory))
    },
    // 表头设置相应事件
    onTableSelect({ value }) {
      // console.log(value)
      if (value && value.length) {
        const arr = []
        this.tempCols.map(v => {
          if (value.includes(v.label)) {
            arr.push(v)
          }
        })
        // console.log([...arr])
        this.cols = arr
        this.doLayout()
      }
    },
    // 设置表头控件选项
    setRightOptions() {
      // console.log(this.cols)
      if (!this.formCtrlRight || !this.formCtrlRight || !this.formCtrlRight.options || !this.cols) return;
      this.tempCols = [...this.cols]
      this.tempCols.map(v => {
        // console.log(v)
        // if (!v.prop) return
        const o = {
          label: v.label,
          value: v.label,
        }
        // if (v.prop === 'order_num') {
        //   o.disabled = true
        // }
        this.formCtrlRight.options.push(o)
        this.defaultTh.push(v.label)
        // this.cols.push(v)
      })
      // console.log([...this.defaultTh])
    },
    // 导出
    Export(name = 'test') {
      this.$confirm("确定要导出文件到Excel?", "导出提示", {
        //这里是加一个导出提示，根据个人喜好，可加可不加   
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        setTimeout(() => {
          var xlsxParam = { raw: true }  // 导出的内容只做解析，不进行格式转换
          const eTable = document.querySelector('.table-wrap .el-table')
          let fix = document.querySelector('.el-table__fixed-right');
          let wb;
          if (fix) { //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
            wb = this.$XLSX.utils.table_to_book(eTable.removeChild(fix), xlsxParam);
            eTable.appendChild(fix);
          } else {
            wb = this.$XLSX.utils.table_to_book(eTable);
          }
          // let tables = document.getElementById('eTable');   //这里是绑定元素，输入你要导出的table表格的id
          // let table_book = this.$XLSX.utils.table_to_book(tables, xlsxParam);
          const table_write = this.$XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array",
          });
          try {
            this.$FileSaver.saveAs(
              new Blob([table_write], { type: "application/octet-stream" }), `${name}.xlsx`   //这里是文件名
            );
          } catch (e) {
            if (typeof console !== "undefined") console.log(e, table_write);
          }
          return table_write;
        }, 500)
      })
    },
    onSizeChange(n) {
      // console.log(n);
      this.limit = n;
      this.getList();
    },
    onCurrentChange(n) {
      // console.log('current change to', n);
      this.page = n;
      this.getList();
    },
    onSelectionChange(arr) {
      this.selection = [...arr]
    },
    onToggleTab({ index }) {
      this.tabIdx = index;
      this.getList();
    },
    onSearch(form) {
      // 搜索前页码重置，避免搜不到
      this.page = 1
      this.formInline = { ...form };
      // console.log({ ...this.formInline });
      this.getList();
    },
    onSearchItemChange({ key }) {
      console.log(key)
      if (['fleet'].includes(key)) {
        this.page = 1;
        this.getList()
      }
    },
    onComSearchChange({ key, value }) {
      // console.log(key, value)
      // console.log({ ...this.formInline })
      // 如果键有值则存,无则不存
      if (key) this.formInline[key] = value
      // console.log({ ...this.formInline })
    },
    onComSelectSearchChange({ key, value }) {
      // console.log(key, value)
      // console.log({ ...this.formInline })
      // 如果键有值则存,无则不存
      if (key) this.formInline[key] = value
      // console.log({ ...this.formInline })
      this.page = 1;
      this.getList()
    },
    onReset() {
      console.log("onReset");
      // console.log({ ...this.formInline })
      // console.log(this.$refs)
      // 重置复合搜索框组件
      const comFormCtrl = this.$refs['comFormCtrl']
      comFormCtrl && comFormCtrl.reset()
      // 重置复合下拉框组件
      const comFormSelect = this.$refs['comFormSelect']
      comFormSelect && comFormSelect.reset()
      // 重置复合日期搜索框组件
      const comFormDate = this.$refs['comFormDate']
      comFormDate && comFormDate.reset()
      // 为所有字段设置初始值
      const obj = {}
      this.formCtrl.map(v => {
        obj[v.keyName] = null
      })
      this.searchKeyOptions.map(v => {
        obj[v.value] = null
      })
      this.baseParams.map(v => {
        if (v == 'year') {
          // 重置为默认年份
          obj[v] = this.DATE_OBJ.y
        } else if (['month', 'predict_loading_date', 'predict_unloading_date', 'addtime'].includes(v) && this.MONTH) {
          // 重置为默认月份
          obj[v] = this.MONTH
        } else {
          obj[v] = this.formInline[v]
        }
      })
      // console.log(obj)
      this.formInline = obj;
      // 清除储存的搜索条件
      const path = this.$route.path
      this.setStore({
        ['formInline' + path]: obj,
      })
      // 回到首页
      this.page = 1;
      // 请求
      this.getList();
      // console.log({ ...this.formInline })
    },
    delete(id) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(id)
        this.delReq(id);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    delReq(id) {
      if (this.loading) return
      this.loading = true
      let url = `${this.baseUrl}/${this.delUrl}`;
      const params = {
        userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        this.loading = false
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },
    getList(staticfresh) {
      if (this.listLoading) return
      this.listLoading = true
      if (!staticfresh) {
        this.tableData = [];
      }
      let url = `${this.baseUrl}/${this.getListUrl}`;
      const params = {
        userid: this.user.id,
        page: this.page,
        limit: this.limit,
      }
      const object = this.formInline
      // console.log('formInline', { ...this.formInline })
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      // console.log(url, params)
      this.post(url, params, (res) => {
        this.listLoading = false
        // console.log('list', res.data)
        this.tableDataHandler(res);
        if (this.$refs.table) {
          // console.log(this.$refs.table.$el)
          this.$refs.table.setScrollTop()
        }
      }, err => {
        this.listLoading = false
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    dataObjHandler(v) {
      const o = {}
      for (const key in v) {
        if (Object.hasOwnProperty.call(v, key)) {
          const ele = v[key]
          if (key.includes('time') && (typeof ele === 'string') && ele.includes(' ')) {
            const arr = ele.split(' ')
            o[key] = arr[0];
          } else {
            o[key] = v[key];
          }
        }
      }
      const { pricing_id } = v
      if (pricing_id) {
        if (pricing_id == 5) {
          o.inton = '-'
          o.unton = '-'
        }
      }
      return o
    },
    tableDataHandler(res) {
      if (typeof res === 'string') {
        this.$message({
          type: 'error',
          message: res
        });
      } else {
        const { count, data } = res
        this.total = count
        if (data && data.length) {
          // console.log(data)
          // this.tableData = [...data]
          this.tableData = data.map(v => {
            return this.dataObjHandler(v)
          })
          this.setListHistory()
          // 后台丢失count会使翻页器隐藏
          if (!count) this.total = data.length
        }
      }
    },
    getTotal(param) {
      const { columns, data } = param;
      // console.log(param)
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0 && column.type !== 'selection') {
          // console.log({...column}, {...data})
          sums[index] = '合计';
          return;
        }
        if (columns[0].type === 'selection' && index === 1) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value)) && this.getTotalProperty.includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            // console.log(value, prev, curr)
            if (!isNaN(value)) {
              return this.keep2(Number(prev) + Number(curr));
            } else {
              return this.keep2(prev);
            }
          }, 0);
          // sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    keep2(n) {
      return (Number(n)).toFixed(2)
    },
    showDialog(str = 'dialog') {
      this.$refs[str] && this.$refs[str].show()
    },
    hideDialog(str = 'dialog') {
      typeof str == 'string' ? null : str = 'dialog'
      this.$refs[str] && this.$refs[str].hide()
    },
    getFleet(all) {
      const params = {}
      // 获取全部车队长，包括未绑定车辆的
      if (all) {
        params['code'] = 2
      }
      this.post(`base/getmyfleet`, params, this.setFleet, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setFleet({ team }) {
      // console.log(team)
      this.formCtrl.map(v => {
        if (v.keyName == 'fleet') {
          this.setCtrlOption(v, team, 'nickname')
        }
      })
      this.$forceUpdate()
    },
    setCtrlOption(v, team, key1, key2) {
      this.$set(v, 'options', [
        { label: '全部', value: '' },
      ])
      team.map(c => {
        v.options.push({
          label: c[key1 || 'name'],
          value: c[key2 || 'id'],
        })
      })
    },
    setQueryParams() {
      const object = this.$route.query
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && object[key]) {
          // this.formInline[key] = object[key];
          this.$set(this.formInline, key, object[key])
        }
      }
    },
    getOptions(params = {}) {
      this.post(`${this.baseUrl}/${this.getOptionUrl}`, params, this.setOptions, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setOptions(res) {
      console.log(res)
    },
    onModalChange({ key, value }) {
      // console.log(key, value)
      // console.log(key === 'money')
      if (key.includes('photo')) {
        this.mform[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
      } else {
        // this.mform[key] = value;
        this.$set(this.mform, key, value)
      }
      // console.log({ ...this.mform })
    },
    onModalSubmit() {
      // console.log({ ...data })
      console.log({ ...this.mform })
      if (this.loading) return
      this.loading = true
      let url = `${this.baseUrl}/${this.modalSubmitUrl}`;
      const params = {
        userid: this.user.id,
      }
      // 基础参数打包
      this.paramsPackage(params, this.mform)
      // 特殊参数打包处理
      this.specialParamsPackage(params)
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        this.loading = false
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    paramsPackage(params, object) {
      // console.log({ ...params })
      // console.log({ ...object })
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }
    },
    // 占位，特定页面中同名函数覆盖
    specialParamsPackage() { },
    reSetListStatus() {
      // console.log('store', { ...this.store })
      if (!this.store) return
      const path = this.$route.path
      if (this.store['page' + path]) {
        this.page = this.store['page' + path]
      }
      if (this.store['limit' + path]) {
        this.limit = this.store['limit' + path]
      }
      if (this.store['formInline' + path]) {
        this.formInline = {
          ...this.formInline,
          ...this.store['formInline' + path]
        }
        // console.log('formInline', { ...this.formInline })
      }
    },
    doLayout() {
      if (this.$refs.table && this.$refs.table.doLayout) {
        this.$refs.table.doLayout()
      }
    },
    getMonthRange(month) {
      let a = []
      if (month) {
        const m = Number(month.split('-')[1])
        const y = Number(month.split('-')[0])
        // console.log(m)
        let d = 30
        if ([1, 3, 5, 7, 8, 10, 12].includes(m)) {
          d = 31
        } else if (m == 2) {
          d = 28
        } else if (m == 2 && ((y % 400 === 0) || (y % 4 === 0 && y % 100 !== 0))) {
          d = 29
        }
        a.push(`${month}-01`, `${month}-${d}`)
      }
      return a
    },
  },
  updated() {
    this.doLayout();
  },
  created() {
    // 先给所有检索字段赋默认值，以便于触发控件渲染
    this.formCtrl.map(v => {
      const val = this.formInline[v.keyName]
      // 直接赋值有时候会引起渲染失效，不保险
      // this.formInline[v.keyName] = val || null
      this.$set(this.formInline, v.keyName, val || null)
    })
    // console.log('formInline', { ...this.formInline })
  },
  mounted() {
    // 检索对象formInline有month参数且没有值，默认赋值上个月，同时储存为重置默认值
    // if (Object.prototype.hasOwnProperty.call(this.formInline, 'month') && !this.formInline.month) {
    //   // 在这里默认赋值上月，如有默认本月的在页面中的created中赋值
    //   this.MONTH = this.LAST_MONTH
    //   this.$set(this.formInline, 'month', this.LAST_MONTH)
    //   this.$forceUpdate()
    // }
    // 恢复列表页检索、滚动、页码等状态
    this.reSetListStatus()
    // console.log('baseParams', [...this.baseParams])
    // console.log('formInline mounted', { ...this.formInline })
    // console.log(this.$route.query)
    // 没有前置参数，且路由中没有参数，可以直接请求
    if (!this.baseParams.length && !Object.keys(this.$route.query).length) {
      // 恢复状态后再搜索
      this.$nextTick(this.getList)
    }
    // 如果搜索条件为空,则赋予搜索条件初始值,以便于触发控件渲染
    // if (!Object.keys(this.formInline).length) {
    //   this.formCtrl.map(v => {
    //     this.formInline[v.keyName] = null
    //   })
    // }
    // this.tabIdx = this.tabIdxMemo(this.$route.path) || 0
    // 设置表头控件选项
    this.setRightOptions()
    // 获取浏览记录
    this.getUserViewHistory()
  },
  beforeRouteLeave(to, from, next) {
    // 监听到页面离开时调用
    // to: 即将要进入的目标的路由对象
    // from: 当前导航正要离开的路由
    // next: 是一个function，一定要调用该方法，否则路由不会跳转。
    // console.log(from)
    // console.log(to)
    const path = this.$route.path
    if (to.path.includes('etail')
      || to.path.includes('view')
      || to.path.includes('fee')
      // 来时的页面没有参数且去的页面有参数，说明是一级列表到二级列表或者详情，排除二级列表之间相互切换的情况，例如合同管理运单列表之间的切换
      || (to.fullPath.includes('?') && !from.fullPath.includes('?'))
    ) {
      const obj = {
        ['page' + path]: this.page,
        ['limit' + path]: this.limit,
        ['formInline' + path]: this.formInline,
      }
      if (this.$refs.table) {
        obj['scrollTop' + path] = this.$refs.table.scrollTop || 0
      }
      this.setStore(obj)
    } else {
      this.setStore({
        ['page' + path]: 1,
        ['limit' + path]: config.PAGE_SIZES[0],
        ['formInline' + path]: {},
        ['scrollTop' + path]: 0,
      })
    }
    // 一定要调用next
    next()
  },
  // watch: {
  //   page: {
  //     deep: true,
  //     handler(newVal, oldVal) {
  //       console.log(newVal, oldVal)
  //     },
  //   }
  // },
}

export default minin